import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC, useCallback, useMemo } from 'react'

import Icon from '@/components/Icon'
import Link from '@/components/Link'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import styles from './Logo.module.scss'
import { routes } from '@/config'

interface LogoProps extends DefaultComponentProps {
  light?: boolean
}

const Logo: FC<LogoProps> = ({ className = '', light = false }) => {
  const router = useRouter()
  const { t } = useTranslation()

  const scrollToTop = useCallback((e: { preventDefault: () => void }) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const props = useMemo(
    () => (router.pathname === routes.HOME ? { onClick: scrollToTop } : {}),
    [router.pathname, scrollToTop]
  )

  return (
    <Link
      {...props}
      className={clsx(styles['logo'], className, {
        [styles['logo_light']]: light
      })}
      href={routes.HOME}
      title={t('forms:buttons.goHome.label') as string}
    >
      <Icon
        className={clsx(styles['logo__icon'], styles['logo__icon_mobile'])}
        name="adsimple/40"
        width={40}
        height={40}
      />
      <Icon
        className={clsx(styles['logo__icon'], styles['logo__icon_desktop'])}
        name="adsimple/48"
        width={152}
        height={48}
      />
    </Link>
  )
}

export default Logo
